<template>
    <div class="container-page pt-12 pb-10 md:pt-20 md:pb-14">
        <div class="max-w-3xl">
            <h1 class="font-display text-[44px] font-semibold leading-[1.05] tracking-[-0.03em] text-ink sm:text-[60px]">
                {{ title }}
            </h1>
            <p class="mt-5 prose-body text-[18px]">
                <slot />
            </p>
        </div>

        <nav v-if="items.length" class="mt-8 flex flex-wrap gap-2">
            <a v-for="item in items" :key="item.id" :href="'#' + item.id"
                class="rounded-full border border-line bg-surface px-4 py-1.5 text-[14px] text-ink-2 transition-colors hover:border-ink hover:text-ink">
                {{ item.name }}
            </a>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true },
        items: { type: Array, default: () => [] }
    }
};
</script>
